import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { useState } from "react";
import { getCategoryUrl } from "../../../utils/url.utils";

const CollectionSidebar = ({ categories = [], loading }) => {
    const [expanded, setExpanded] = useState({});

    const toggle = (i) =>
        setExpanded((p) => ({ ...p, [i]: !p[i] }));

    if (loading) {
        return (
            <aside className="sidebar">
                <Skeleton height={24} width={120} />
            </aside>
        );
    }

    return (
        <aside className="sidebar filter-section-fixed  " style={{ paddingTop:"3px"}}>
            <h4>Filters</h4>
            {categories.map((cat, idx) => {
                const showAll = expanded[idx];
                const subs = showAll
                    ? cat.subcategories
                    : cat.subcategories?.slice(0, 5);

                return (
                    <div key={idx} className="category-group pointer-crusser">
                        <Link to={getCategoryUrl(cat.action_url)} title={cat.name}>
                            <h4>{cat.name}</h4>
                        </Link>
                        <ul>
                            {subs?.map((sub) => (
                                <li key={sub.id}>
                                    <Link
                                        to={getCategoryUrl(cat.action_url, sub.action_url)} title={sub.name}
                                    >
                                        {sub.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>

                        {cat.subcategories?.length > 5 && (
                            <div onClick={() => toggle(idx)} className="show-more-link">
                                {showAll ? "− Show Less" : "+ Show More"}
                            </div>
                        )}
                    </div>
                );
            })}
        </aside>
    );
};

export default CollectionSidebar;
